import { Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useState, useEffect } from "react";
import axios from "axios";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const AdminNavbar = () => {


    const signoutHandler = () => {
        const cart_Products =
            JSON.parse(localStorage.getItem("productsInCart")) || [];
        const token = JSON.parse(localStorage.getItem("userTokenTime")).token;
        localStorage.removeItem("userTokenTime");
        localStorage.removeItem("role");
        localStorage.removeItem("productsInCart");
        axios
            .post(SERVER_URL+
                "/api/signout",
                {
                    cart: cart_Products,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                }
            )
            .then((res) => {
                console.log("signed out successfully!");
                window.location = process.env.REACT_APP_LINK
            })
            .catch((err) => {
                console.log(err);
            });
    };


    return (
        <>
            <nav className="navbar navbar-expand-lg nav navbar-light bg-light">
                <Link to="/">
                    <h3 className="icon">ST🌐RE</h3>
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">



                    <div className="header__right ml-auto" style={{ display: "flex", alignItems: "center" }}>



                        {!localStorage.getItem("userTokenTime") ? (
                            <>
                                <Link to="/signin">
                                    <div className="">Login</div>
                                </Link>
                            </>
                        ) : (
                            <div className="dropdown-item" onClick={signoutHandler}>
                                Sign Out
                            </div>
                        )}




                    </div>
                </div>
            </nav>
        </>
    );
};

export default AdminNavbar;
